'use client'

import {cx} from '@local/utils/cx'
import {expoOut} from 'eases'
import {animate} from 'motion'
import {useEffect, useRef} from 'react'

export interface ComingSoonTextSmallProps {
	className?: string
	surtitle:string;
	text:string;
}

export const ComingSoonTextSmall = ({className, surtitle, text = ''}: ComingSoonTextSmallProps) => {
	const containerRef = useRef<HTMLDivElement>(null)

	useEffect(() => {
		if (containerRef.current) {
			animate(
				containerRef.current,
				{transform: 'translate3d(0,0,0)', opacity: 1, visibility: 'visible'},
				{duration: 1, delay: 7.8, easing: expoOut},
			)
		}
	}, [containerRef.current])

	if (!text) return null

	return (
		<div
			className={cx(
				className,
				'text-grey-5 text-center relative span-w-3 md-max:mx-auto mb-24 mt-auto z-10',
				'md:fixed md:span-w-4 md:mb-30 md:bottom-0 md:left-1/2 md:-translate-x-1/2 md:transform',
				'lg:span-w-3',
			)}>
			<div
				ref={containerRef}
				className={cx(
					'flex flex-col justify-center items-center gap-12 lg:gap-24',
					'opacity-0 transform-gpu translate-y-[75%]',
				)}>
				{surtitle && <p className='text-10 uppercase font-medium tracking-widest'>{surtitle}</p>}
				<h2 className='font-serif md-max:w-11/12 text-18 lg:text-24'>
					{text}
				</h2>
			</div>
		</div>
	)
}
